// Type definition used to map each asset class page to values like API filters, titles, descriptions, icons, page routes, etc.
export type AssetClassPage =
    | "stablecoins"
    | "treasuries"
    | "government_bonds"
    | "credit"
    | "stocks"
    | "pe_vc"
    | "active_strategies"
    | "commodities"
    | "real_estate";

// // // //

/**
 * AssetClass
 * Row returned by the /v4/asset_classes API
 */
export interface AssetClass {
    id: number;
    slug: string;
    name: string;
    description: string;
    icon_url: string | null;
    color_hex: string | null;
}

export enum AssetClassColumns {
    id = "id",
    slug = "slug",
    name = "name",
    description = "description",
    icon_url = "icon_url",
    color_hex = "color_hex",
}
